import * as _ from "lodash";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { AuthenticationInfoService } from "@app/core/guards/authentication-info.service";
import { ImportMissingInvoiceNumberModel } from "@app/core/models/imports/import-missing-invoice-number.model";
import { ImportService } from "@app/core/services/import.service";
import { ModalComponent } from "@app/shared/components/modal/modal.component";
import { ModalHelper } from "@app/shared/models/modal-helper.model";

export class AnalysisMissingInvoiceNumberActionService {

    importMissingInvoiceNumberDocument: ImportMissingInvoiceNumberModel;

    protected unsubscribe$: Subject<boolean> = new Subject<boolean>();

    constructor(protected importService: ImportService,
        protected authenticationInfoService: AuthenticationInfoService,
        public dialog: MatDialog) {
    }

    get IsPickedByMe(): boolean {
        return this.importMissingInvoiceNumberDocument?.PickedByUserId === this.authenticationInfoService.authentificatedUser.Id;
    }

    get IsPicked(): boolean {
        return !_.isNil(this.importMissingInvoiceNumberDocument.PickedByUserId);
    }

    onPick = () => {
        const isAlreadyPickedBySomeoneElse = this.IsPicked && !this.IsPickedByMe;
        if (isAlreadyPickedBySomeoneElse) {
            const confimModal = new ModalHelper().getConfirmationConfig(`Attention, ce document est affecté à quelqu'un d'autre. Voulez-vous quand même procéder ?`);
            const dialogRef = this.dialog.open(ModalComponent, confimModal);
            dialogRef.afterClosed()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((isSuccess: boolean) => {
                    if (isSuccess) {
                        this.pick();
                    }
                });
            return;
        }
        this.pick();
    };

    pick = () => {
        this.importService.pickImportMissingInvoiceNumberDocument(this.importMissingInvoiceNumberDocument.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.markDocumentAsPicked();
            });
    }

    onUnpick = () => {
        this.importService.unpickImportMissingInvoiceNumberDocument(this.importMissingInvoiceNumberDocument.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.markDocumentAsUnPicked();
            });
    };

    markDocumentAsPicked() {
        this.importMissingInvoiceNumberDocument.PickedByUserName = this.authenticationInfoService.authentificatedUser.FullName;
        this.importMissingInvoiceNumberDocument.PickedByUserId = this.authenticationInfoService.authentificatedUser.Id;
        this.importMissingInvoiceNumberDocument.PickedAt = new Date();
    }

    markDocumentAsUnPicked() {
        this.importMissingInvoiceNumberDocument.PickedByUserName = null;
        this.importMissingInvoiceNumberDocument.PickedByUserId = null;
        this.importMissingInvoiceNumberDocument.PickedAt = null;
    }
}